import {Inject, Injectable} from '@angular/core';
import {EmployeeEditHistoryResource, EmployeeEditHistoryEntry} from 'resteasytox';
import {Observable} from 'rxjs/Observable';
import {from} from 'rxjs/observable/from';
import * as moment from 'moment';
import {Moment} from 'moment';
import * as _ from 'lodash';
import {isBetween} from 'ngx-bootstrap/bs-moment/utils/date-compare';
import {WrapperService} from '../api/wrapper.service';

// export type EmployeeEditHistoryData = {[employeeId: string]: Timecard };
export interface EmployeeEditHistoryDetails {
	employeeType?: number;
	payFrequency?: string;
	// payType?: string;
	quickBookName?: string;
	workEndTime?: number;
	workStartTime?: number;
}
/*
 Service contains cached data of Pay Status History for all employees
 */
@Injectable()
export class EmployeesEditHistoryCacheService {

	private data: {[employeeId: number]: EmployeeEditHistoryEntry[] } = {};

	constructor(
		@Inject('EmployeeEditHistoryResource') private employeeEditHistoryResource: EmployeeEditHistoryResource,
		private wrapperService: WrapperService
	) {
	}

	public updateData(employees?: number[]): Observable<any> {
		const data: any = {
			employees: []
		};
		// Use WrapperService instead of RESTEasy client to ensure proper authentication
		return this.wrapperService.wrapPostRequest('/employeeEditHistory/full', data, 'updateEmployeeEditHistory')
			.map((res: any) => {
				this.data = res.payload;
				console.log('data updated');
			})
			.catch((err: any) => {
				alert('Technical error');
				console.error(err);
				return Observable.throw(err);
			});
	}

	public getEmployeeEditHistory(employeeId: number): EmployeeEditHistoryEntry[] {
		return this.data[employeeId];
	}

	public getEmployeeDetailsAtDate(employeeId: number, date: number): EmployeeEditHistoryDetails {
		const d: Moment = moment(date);
		const employeeData: EmployeeEditHistoryEntry[] = this.getEmployeeEditHistory(employeeId);

		if (!employeeData) { return null; }

		if ( d.isBefore(moment(employeeData[0].startDate))) {
			return null;
		}

		if (_.last(employeeData).endDate && d.isAfter(moment(_.last(employeeData).endDate))) {
			return null;
		}
		const details: EmployeeEditHistoryDetails = {};

		_.each(employeeData, (period: EmployeeEditHistoryEntry) => {
			if (d.isBefore(moment(period.startDate))) {
				return false;
			}
			_.mergeWith(details,  {
				employeeType: period.employeeType,
				payFrequency: period.payFrequency,
				// payType: period.payType,
				quickBookName: period.quickBookName,
				workEndTime: period.workEndTime,
				workStartTime: period.workStartTime
			}, (objValue: any, srcValue: any) => {
				if (srcValue === null || srcValue === undefined) {
					return objValue;
				} else {
					return srcValue;
				}
			});

		});

		return details;
	}

	public getEmployeeEntriesForPeriod(employeeId: number, from: number, to: number): EmployeeEditHistoryEntry[] {
		const history: EmployeeEditHistoryEntry[] = this.getEmployeeEditHistory(employeeId);
		return _.filter(history, (entry: EmployeeEditHistoryEntry) => {
			if (entry.endDate) {
				return this.isBetween(entry.startDate, from, to) || this.isBetween(entry.endDate, from, to);
			} else {
				return entry.startDate <= from || this.isBetween(entry.startDate, from, to);

			}
		});
	}

	private isBetween(point: number, from: number, to: number): boolean {
		return point >= from && point <= to;
	}

}



// WEBPACK FOOTER //
// ./src/app/core/employee-edit-history-cache.service.ts